module.exports = __webpack_public_path__ + "static/img/zhongyu.9fc32626.png";